import { axiosCore } from './http-core-service';
import { ContractFormInfosDto } from './dtos/form/contract-form-infos.dto';

/** Méthode qui fait une appel api pour le paiement en ligne.
 * @returns {Promise<RequestDto[]>} - A Promise that resolves to an array of RequestDto objects.
 * @param infosContract
 * @param captcha
 */
export const paymentLoggedOff = async (infosContract: ContractFormInfosDto, captcha: string): Promise<string> => {
    const response = await axiosCore.get(
        `/paiement?captcha=${captcha}&referenceAbonnement=${infosContract.referenceContrat.trim()}&` +
            `referenceFacture=${infosContract.referenceFacture.trim()}&montantDu=${infosContract.montantFacture}` +
            (infosContract.email ? `&email=${infosContract.email}` : '')
    );
    return response.data.urlPaiement;
};
